import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ComponentProps, ComponentRef } from "@ionic/core";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  constructor(private readonly modalController: ModalController) {}

  public async presentModal<T extends ComponentRef = ComponentRef>(
    component: T,
    componentProps: ComponentProps<T>,
    initialBreakpoint?: number,
  ): Promise<HTMLIonModalElement> {
    const modal = await this.modalController.create({
      component: component,
      componentProps: componentProps,
      handleBehavior: "cycle",
      breakpoints: [0, 0.25, 0.5, 0.75, 0.9],
      initialBreakpoint: initialBreakpoint ?? 0.9,
    });

    await modal.present();

    return modal;
  }
}
